<template>
  <section class="hero-modern" id="hero">
    <HeroBackground />
    
    <div class="container h-100">
      <div class="row h-100 align-items-center">
        <div class="col-lg-6">
          <div class="hero-content">

            <HeroTitle
              title="Il tuo Codice Lotteria sempre a portata di mano"
              highlightText="Codice Lotteria"
            />

            <p class="hero-subtitle fade-in-up delay-2">
              L'app più semplice e veloce per gestire il tuo codice lotteria e le tue liste della spesa. <strong>Gratuita, sicura e senza registrazione.</strong>
            </p>

            <HeroActions
              primaryText="Scarica Ora"
              primaryIcon="icon-cloud-download"
              primaryHref="#download"
              secondaryText="Scopri di più"
              secondaryIcon="icon-layers"
              secondaryHref="#features"
            />

            <HeroStats :stats="statsData" />
          </div>
        </div>

        <div class="col-lg-6">
          <div class="hero-visual fade-in-right delay-2">
            <div class="device-showcase">
              <HeroDevice
                class="device-mockup"
                imageAlt="Screenshot dell'app AppScontrini"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HeroDevice from '@/components/home/hero/HeroDevice.vue'
import HeroBackground from '@/components/home/hero/HeroBackground.vue'
import HeroBadge from '@/components/home/hero/HeroBadge.vue'
import HeroTitle from '@/components/home/hero/HeroTitle.vue'
import HeroActions from '@/components/home/hero/HeroActions.vue'
import HeroStats from '@/components/home/hero/HeroStats.vue'

export default {
  name: 'HeroSection',
  components: {
    HeroDevice,
    HeroBackground,
    HeroBadge,
    HeroTitle,
    HeroActions,
    HeroStats
  },
  data() {
    return {
      statsData: [
        { icon: 'icon-cloud-download', number: '100k+', label: 'Download' },
        { icon: 'icon-star', number: '4.8', label: 'Valutazione' },
        { icon: 'icon-users', number: '50k+', label: 'Utenti Attivi' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/animations";
@import "@/styles/hero";
@import "@/styles/cards";
</style>
